export default __webpack_public_path__ + "static/media/1.1191c9c1.png";